/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLogs = createReactComponent("outline", "logs", "IconLogs", [["path", { "d": "M4 12h.01", "key": "svg-0" }], ["path", { "d": "M4 6h.01", "key": "svg-1" }], ["path", { "d": "M4 18h.01", "key": "svg-2" }], ["path", { "d": "M8 18h2", "key": "svg-3" }], ["path", { "d": "M8 12h2", "key": "svg-4" }], ["path", { "d": "M8 6h2", "key": "svg-5" }], ["path", { "d": "M14 6h6", "key": "svg-6" }], ["path", { "d": "M14 12h6", "key": "svg-7" }], ["path", { "d": "M14 18h6", "key": "svg-8" }]]);

export { IconLogs as default };
//# sourceMappingURL=IconLogs.mjs.map
